

    
    <div class="step-container">
      <ng-template #labelTen>{{ getTranslation('documents.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('documents.title') : getTranslation('documents.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>
  



      <nb-accordion *ngIf="!isPreviewMode && isEditable">
        <nb-accordion-item>
          <nb-accordion-item-header>📸 {{ getTranslation('documents.guidelines.photo.header') }}</nb-accordion-item-header>
          <nb-accordion-item-body>
            <ul>
              <li>{{ getTranslation('documents.guidelines.photo.li1') }}</li>
              <li>{{ getTranslation('documents.guidelines.photo.li2') }}</li>
              <li>{{ getTranslation('documents.guidelines.photo.li3') }}</li>
              <li>{{ getTranslation('documents.guidelines.photo.li4') }}</li>
              <!-- <li>{{ getTranslation('documents.guidelines.photo.li5') }}</li> -->
            </ul>
          </nb-accordion-item-body>
        </nb-accordion-item>
      
        <nb-accordion-item>
          <nb-accordion-item-header>🪪 {{ getTranslation('documents.guidelines.id.header') }}</nb-accordion-item-header>
          <nb-accordion-item-body>
            <ul>
              <li>{{ getTranslation('documents.guidelines.id.li1') }}</li>
              <li>{{ getTranslation('documents.guidelines.id.li2') }}</li>
              <li>{{ getTranslation('documents.guidelines.id.li3') }}</li>
              <li>{{ getTranslation('documents.guidelines.id.li4') }}</li>
            </ul>
          </nb-accordion-item-body>
        </nb-accordion-item>
            </nb-accordion>

      <!-- File Validation Info -->






      <!-- ================================Blue Header========================= -->


      <!-- <div class="alert alert-info mt-3 mb-4" role="alert" *ngIf="!isPreviewMode">
        <div class="d-flex align-items-center">
          <i class="fas fa-info-circle me-2"></i>
          <div>
            <strong>{{ getTranslation('documents.fileInfo.title') }}</strong>
            <ul class="mb-0 mt-1">
              <li>{{ getTranslation('documents.fileInfo.li1') }}</li>
              <li>{{ getTranslation('documents.fileInfo.li2') }}</li>
              <li>{{ getTranslation('documents.fileInfo.li3') }}</li>
            </ul>
          </div>
        </div>
      </div> -->
  
      <br/>



      <!-- <div class="step-subtitle mb-4">Select Document and Upload</div>
      <div class="form-row">
        <div class="form-group col-md-6 pr-5">
          <label for="name" class="form-label">Mandatory Documents:  <span class="text-danger">*</span></label>
          <div class="d-flex justify-content-between fileupl">
            <select id="inputState" class="form-select form-control pr-4">
              <option selected>Select Mandatory Document</option>
              <option>Option 1</option>
              <option>Option 2</option>
            </select>
            <button class="uplbtn ml-4 d-flex">
              <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.25 14.75C7.25 15.1642 6.91423 15.5 6.5 15.5C6.08577 15.5 5.75 15.1642 5.75 14.75V5.68565L3.28033 8.15532C2.98743 8.4482 2.51257 8.4482 2.21967 8.15532C1.92678 7.86245 1.92678 7.38755 2.21967 7.09468L5.96968 3.34468C6.26255 3.0518 6.73745 3.0518 7.03032 3.34468L10.7803 7.09468C11.0732 7.38755 11.0732 7.86245 10.7803 8.15532C10.4874 8.4482 10.0126 8.4482 9.71968 8.15532L7.25 5.68565V14.75ZM1.25 2C0.83579 2 0.5 1.66422 0.5 1.25C0.5 0.835775 0.83579 0.5 1.25 0.5H11.75C12.1642 0.5 12.5 0.835775 12.5 1.25C12.5 1.66422 12.1642 2 11.75 2H1.25Z" fill="white"/>
              </svg>
              <span class="ml-2">UPLOAD</span>
              <input type="file" name="file"/>
            </button>
          </div>
        </div>
        <div class="form-group col-md-5"> 
          <label for="details" class="form-label">Non-Mandatory Documents:  </label>
          <div class="d-flex justify-content-between fileupl">
            <select id="inputState" class="form-select form-control pr-4">
              <option selected>Select Non-Mandatory Document</option>
              <option>Option 1</option>
              <option>Option 2</option>
            </select>
            <button class="uplbtn ml-4 d-flex">
              <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.25 14.75C7.25 15.1642 6.91423 15.5 6.5 15.5C6.08577 15.5 5.75 15.1642 5.75 14.75V5.68565L3.28033 8.15532C2.98743 8.4482 2.51257 8.4482 2.21967 8.15532C1.92678 7.86245 1.92678 7.38755 2.21967 7.09468L5.96968 3.34468C6.26255 3.0518 6.73745 3.0518 7.03032 3.34468L10.7803 7.09468C11.0732 7.38755 11.0732 7.86245 10.7803 8.15532C10.4874 8.4482 10.0126 8.4482 9.71968 8.15532L7.25 5.68565V14.75ZM1.25 2C0.83579 2 0.5 1.66422 0.5 1.25C0.5 0.835775 0.83579 0.5 1.25 0.5H11.75C12.1642 0.5 12.5 0.835775 12.5 1.25C12.5 1.66422 12.1642 2 11.75 2H1.25Z" fill="white"/>
              </svg>
              <span class="ml-2">UPLOAD</span>
              <input type="file" name="file"/>
            </button>
          </div>
        </div>
      </div> -->

  


      <table class="table mb-4">
        <thead>
          <tr>
            <th class="text-center" style="font-size: 0.9rem; font-weight: 600; display: none;">{{ getTranslation('documents.table.srNo') }}</th>
            <th class="text-center" style="font-size: 0.9rem; font-weight: 600;">{{ getTranslation('documents.table.documentName') }}</th>
            <th class="text-center" style="font-size: 0.9rem; font-weight: 600;">{{ getTranslation('documents.table.fileName') }}</th>
            <th class="text-center" style="font-size: 0.9rem; font-weight: 600;" *ngIf="!isPreviewMode && isEditable">{{ getTranslation('documents.table.action') }}</th>
          </tr>
          <tr class="table-light">
            <td colspan="3" class="text-center">
              <small class="text-muted">
                <i class="fas fa-info-circle me-1"></i>
                <strong>{{ getTranslation('documents.table.infoTitle') }}</strong> 
                {{ getTranslation('documents.table.infoText') }}
              </small>
            </td>
          </tr>
        </thead>
        <tbody>


          <!-- <tr>
            <td colspan="4" class="text-center"><span class="tabsubtitle">{{ getTranslation('documents.section.mandatory') }}</span></td>
          </tr> -->




          <tr>
            <td class="text-center" style="display: none;">1 </td>
            <td>
              {{ getTranslation('documents.doc.passportPhoto') }}
              <div class="text-danger small-text" *ngIf="showValidationErrors && getDocumentsByType(DocumentType.ProfilePic).length === 0">{{ getTranslation('documents.requiredMark') }}</div>
            </td>
            <td>
              <div *ngIf="getDocumentsByType(DocumentType.ProfilePic).length > 0; else noFileProfile" class="documents-grid">
                <div *ngFor="let doc of getDocumentsByType(DocumentType.ProfilePic)" class="document-item profile-photo-item">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div class="d-flex align-items-center gap-2 flex-grow-1">
                      <div class="profile-photo-container"
                           (mouseenter)="showImagePreview($event, doc.DocUrl)"
                           (mouseleave)="hideImagePreview()">
                        <img [src]="doc.DocUrl" [alt]="doc.DocNameByUser" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; border: 1px solid #ddd; display: block; min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px; cursor: pointer;">
                      </div>
                      <a [href]="doc.DocUrl" class="text-primary text-decoration-none" target="_blank">{{doc.DocNameByUser}}</a>
                    </div>
                    <div *ngIf="!isPreviewMode && isEditable" 
                         class="action-btn-wrapper delete-btn-wrapper" 
                         [title]="getTranslation('documents.deleteFileTooltip')"
                         (click)="deleteDocument(doc.Id, doc.DocNameByUser)">
                      <div class="action-btn delete-btn">
                        <svg width="16" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noFileProfile>
                <div class="d-flex flex-column align-items-center">
                  <div class="profile-photo-container"
                       (mouseenter)="showImagePreview($event, 'assets/progress1.jpg')"
                       (mouseleave)="hideImagePreview()">
                    <img src="assets/progress1.jpg" alt="Profile Photo" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; border: 1px solid #ddd; display: block; min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px; cursor: pointer;">
                  </div>
                  <span class="mt-1 text-muted">{{ getTranslation('documents.noFile') }}</span>
                </div>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode && isEditable">
              <div class="d-flex justify-content-center align-items-center gap-3">
                <!-- Add Icon -->
                <div class="action-btn-wrapper add-btn-wrapper" [title]="getTranslation('documents.addFileTooltip.photo')">
                  <input type="file" name="file" multiple="true" accept=".jpg,.jpeg,.png"
                    class="file-input-overlay"
                    (change)="onFileSelected(DocumentType.ProfilePic, $event)" />
                  <div class="action-btn add-btn">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                </div>
              </div>
            </td>
          </tr>


          <!-- Validation message for Passport size photograph -->
          <tr *ngIf="showValidationErrors && getDocumentsByType(DocumentType.ProfilePic).length === 0">
            <td colspan="3" class="text-center">
              <div class="alert alert-danger mb-0" role="alert">
                <i class="fas fa-exclamation-triangle me-2"></i>
                {{ getTranslation('documents.validation.passportRequired') }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-center" style="display: none;">2 </td>
            <td>
              {{ getTranslation('documents.doc.aadharCard') }}
              <div class="text-danger small-text" *ngIf="showValidationErrors && getDocumentsByType(DocumentType.AadharCard).length === 0">{{ getTranslation('documents.requiredMark') }}</div>
            </td>
            <td class="text-center">
              <div *ngIf="getDocumentsByType(DocumentType.AadharCard).length > 0; else noFileAadhar" class="documents-grid">
                <div *ngFor="let doc of getDocumentsByType(DocumentType.AadharCard)" class="document-item">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <a [href]="doc.DocUrl" class="text-primary text-decoration-none" target="_blank">{{doc.DocNameByUser}}</a>
                    <div *ngIf="!isPreviewMode && isEditable" 
                         class="action-btn-wrapper delete-btn-wrapper" 
                         [title]="getTranslation('documents.deleteFileTooltip')"
                         (click)="deleteDocument(doc.Id, doc.DocNameByUser)">
                      <div class="action-btn delete-btn">
                        <svg width="16" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noFileAadhar>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode && isEditable">
              <div class="d-flex justify-content-center align-items-center gap-3">
                <!-- Add Icon -->
                <div class="action-btn-wrapper add-btn-wrapper" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    class="file-input-overlay"
                    (change)="onFileSelected(DocumentType.AadharCard, $event)" />
                  <div class="action-btn add-btn">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <!-- Validation message for Aadhaar card -->
          <tr *ngIf="showValidationErrors && getDocumentsByType(DocumentType.AadharCard).length === 0">
            <td colspan="3" class="text-center">
              <div class="alert alert-danger mb-0" role="alert">
                <i class="fas fa-exclamation-triangle me-2"></i>
                {{ getTranslation('documents.validation.aadharRequired') }}
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="text-center"><span class="tabsubtitle">Non-Mandatory Documents</span></td>
          </tr>

          <tr *ngIf="false">
            <td class="text-center" style="display: none;">3 </td>
            <td>{{ getTranslation('documents.doc.photoIdProof') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentByType(DocumentType.PhotoIdProof); else noFilePhotoId">
                <a [href]="getDocumentByType(DocumentType.PhotoIdProof)?.DocUrl" class="text-primary text-decoration-none">{{getDocumentByType(DocumentType.PhotoIdProof)?.DocNameByUser}}</a>
              </div>
              <ng-template #noFilePhotoId>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode && isEditable">
              <div class="d-flex justify-content-center align-items-center gap-2">
                <!-- Add Icon -->
                <div style="position: relative; cursor: pointer;" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"
                    (change)="onFileSelected(DocumentType.PhotoIdProof, $event)" />
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer !important;" class="add-icon">
                    <path
                      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                      fill="#009FFD" />
                  </svg>
                </div>
                <!-- Delete Icon -->
                <svg *ngIf="getDocumentByType(DocumentType.PhotoIdProof)" 
                     width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" 
                     style="cursor: pointer;" 
                     [title]="getTranslation('documents.deleteFileTooltip')"
                     (click)="deleteDocument(getDocumentByType(DocumentType.PhotoIdProof)?.Id, getDocumentByType(DocumentType.PhotoIdProof)?.DocNameByUser)"
                     class="delete-icon">
                  <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="#E33F4E"/>
                </svg>
              </div>
            </td>
          </tr>

          <tr *ngIf="false">
            <td class="text-center" style="display: none;">4 </td>
            <td>{{ getTranslation('documents.doc.panCard') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentByType(DocumentType.PanCard); else noFilePanCard">
                <a [href]="getDocumentByType(DocumentType.PanCard)?.DocUrl" class="text-primary text-decoration-none">{{getDocumentByType(DocumentType.PanCard)?.DocNameByUser}}</a>
              </div>
              <ng-template #noFilePanCard>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode && isEditable">
              <div class="d-flex justify-content-center align-items-center gap-2">
                <!-- Add Icon -->
                <div style="position: relative; cursor: pointer;" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"
                    (change)="onFileSelected(DocumentType.PanCard, $event)" />
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer !important;" class="add-icon">
                    <path
                      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                      fill="#009FFD" />
                  </svg>
                </div>
                <!-- Delete Icon -->
                <svg *ngIf="getDocumentByType(DocumentType.PanCard)" 
                     width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" 
                     style="cursor: pointer;" 
                     [title]="getTranslation('documents.deleteFileTooltip')"
                     (click)="deleteDocument(getDocumentByType(DocumentType.PanCard)?.Id, getDocumentByType(DocumentType.PanCard)?.DocNameByUser)"
                     class="delete-icon">
                  <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="#E33F4E"/>
                </svg>
              </div>
            </td>
          </tr>

          <tr>
            <td class="text-center" style="display: none;">5 </td>
            <td>{{ getTranslation('documents.doc.resume') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentsByType(DocumentType.Resume).length > 0; else noFileResume" class="documents-grid">
                <div *ngFor="let doc of getDocumentsByType(DocumentType.Resume)" class="document-item">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <a [href]="doc.DocUrl" class="text-primary text-decoration-none" target="_blank">{{doc.DocNameByUser}}</a>
                    <div *ngIf="!isPreviewMode && isEditable" 
                         class="action-btn-wrapper delete-btn-wrapper" 
                         [title]="getTranslation('documents.deleteFileTooltip')"
                         (click)="deleteDocument(doc.Id, doc.DocNameByUser)">
                      <div class="action-btn delete-btn">
                        <svg width="16" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noFileResume>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode" >
              <div class="d-flex justify-content-center align-items-center gap-3">
                <!-- Add Icon -->
                <div class="action-btn-wrapper add-btn-wrapper" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    class="file-input-overlay"
                    (change)="onFileSelected(DocumentType.Resume, $event)" />
                  <div class="action-btn add-btn">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr *ngIf="false">
            <td class="text-center" style="display: none;">6 </td>
            <td>{{ getTranslation('documents.doc.sevaProfileDoc') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentByType(DocumentType.SevaProfileDoc); else noFileSevaProfileDoc">
                <a [href]="getDocumentByType(DocumentType.SevaProfileDoc)?.DocUrl" class="text-primary text-decoration-none">{{getDocumentByType(DocumentType.SevaProfileDoc)?.DocNameByUser}}</a>
              </div>
              <ng-template #noFileSevaProfileDoc>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode" >
              <div class="d-flex justify-content-center align-items-center gap-2">
                <!-- Add Icon -->
                <div style="position: relative; cursor: pointer;" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"
                    (change)="onFileSelected(DocumentType.SevaProfileDoc, $event)" />
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer !important;" class="add-icon">
                    <path
                      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                      fill="#009FFD" />
                  </svg>
                </div>
                <!-- Delete Icon -->
                <svg *ngIf="getDocumentByType(DocumentType.SevaProfileDoc)" 
                     width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" 
                     style="cursor: pointer;" 
                     [title]="getTranslation('documents.deleteFileTooltip')"
                     (click)="deleteDocument(getDocumentByType(DocumentType.SevaProfileDoc)?.Id, getDocumentByType(DocumentType.SevaProfileDoc)?.DocNameByUser)"
                     class="delete-icon">
                  <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="#E33F4E"/>
                </svg>
              </div>
            </td>
          </tr>

          <tr *ngIf="false">
            <td class="text-center" style="display: none;">7 </td>
            <td>{{ getTranslation('documents.doc.vsDocument') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentByType(DocumentType.VSDoc); else noFileVSDoc">
                <a [href]="getDocumentByType(DocumentType.VSDoc)?.DocUrl" class="text-primary text-decoration-none">{{getDocumentByType(DocumentType.VSDoc)?.DocNameByUser}}</a>
              </div>
              <ng-template #noFileVSDoc>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode" >
              <div class="d-flex justify-content-center align-items-center gap-2">
                <!-- Add Icon -->
                <div style="position: relative; cursor: pointer;" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"
                    (change)="onFileSelected(DocumentType.VSDoc, $event)" />
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer !important;" class="add-icon">
                    <path
                      d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                      fill="#009FFD" />
                  </svg>
                </div>
                <!-- Delete Icon -->
                <svg *ngIf="getDocumentByType(DocumentType.VSDoc)" 
                     width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" 
                     style="cursor: pointer;" 
                     [title]="getTranslation('documents.deleteFileTooltip')"
                     (click)="deleteDocument(getDocumentByType(DocumentType.VSDoc)?.Id, getDocumentByType(DocumentType.VSDoc)?.DocNameByUser)"
                     class="delete-icon">
                  <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="#E33F4E"/>
                </svg>
              </div>
            </td>
          </tr>

          <tr>
            <td class="text-center" style="display: none;">8 </td>
            <td>{{ getTranslation('documents.doc.other') }}</td>
            <td class="text-center">
              <div *ngIf="getDocumentsByType(DocumentType.Other).length > 0; else noFileOther" class="documents-grid">
                <div *ngFor="let doc of getDocumentsByType(DocumentType.Other)" class="document-item">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <a [href]="doc.DocUrl" class="text-primary text-decoration-none" target="_blank">{{doc.DocNameByUser}}</a>
                    <div *ngIf="!isPreviewMode && isEditable" 
                         class="action-btn-wrapper delete-btn-wrapper" 
                         [title]="getTranslation('documents.deleteFileTooltip')"
                         (click)="deleteDocument(doc.Id, doc.DocNameByUser)">
                      <div class="action-btn delete-btn">
                        <svg width="16" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.85399 2.75H11.3952C11.3952 1.92157 10.6025 1.25 9.62461 1.25C8.6467 1.25 7.85399 1.92157 7.85399 2.75ZM6.52602 2.75C6.52602 1.30025 7.9133 0.125 9.62461 0.125C11.3359 0.125 12.7232 1.30025 12.7232 2.75H17.8138C18.1805 2.75 18.4777 3.00184 18.4777 3.3125C18.4777 3.62316 18.1805 3.875 17.8138 3.875H16.6459L15.6084 12.9584C15.4437 14.4001 14.0136 15.5 12.3038 15.5H6.94538C5.23571 15.5 3.80558 14.4001 3.6409 12.9584L2.60327 3.875H1.43547C1.06876 3.875 0.771484 3.62316 0.771484 3.3125C0.771484 3.00184 1.06876 2.75 1.43547 2.75H6.52602ZM8.29664 6.3125C8.29664 6.00184 7.99936 5.75 7.63266 5.75C7.26595 5.75 6.96867 6.00184 6.96867 6.3125V11.9375C6.96867 12.2481 7.26595 12.5 7.63266 12.5C7.99936 12.5 8.29664 12.2481 8.29664 11.9375V6.3125ZM11.6166 5.75C11.2499 5.75 10.9526 6.00184 10.9526 6.3125V11.9375C10.9526 12.2481 11.2499 12.5 11.6166 12.5C11.9833 12.5 12.2806 12.2481 12.2806 11.9375V6.3125C12.2806 6.00184 11.9833 5.75 11.6166 5.75Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noFileOther>
                <span class="text-muted">{{ getTranslation('documents.noFile') }}</span>
              </ng-template>
            </td>
            <td class="text-center"  *ngIf="!isPreviewMode && isEditable">
              <div class="d-flex justify-content-center align-items-center gap-3">
                <!-- Add Icon -->
                <div class="action-btn-wrapper add-btn-wrapper" [title]="getTranslation('documents.addFileTooltip.default')">
                  <input type="file" name="file" multiple="true" accept=".pdf,.jpg,.jpeg,.png"
                    class="file-input-overlay"
                    (change)="onFileSelected(DocumentType.Other, $event)" />
                  <div class="action-btn add-btn">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 4.25C7.71523 4.25 7.47987 4.46161 7.4426 4.73617L7.4375 4.8125V7.4375H4.8125C4.50184 7.4375 4.25 7.68935 4.25 8C4.25 8.28477 4.46161 8.52013 4.73617 8.5574L4.8125 8.5625H7.4375V11.1875C7.4375 11.4981 7.68935 11.75 8 11.75C8.28477 11.75 8.52013 11.5384 8.5574 11.2639L8.5625 11.1875V8.5625H11.1875C11.4981 8.5625 11.75 8.31065 11.75 8C11.75 7.71523 11.5384 7.47987 11.2639 7.4426L11.1875 7.4375H8.5625V4.8125C8.5625 4.50184 8.31065 4.25 8 4.25Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>

      </table>

      <!-- Buttons start -->
      <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode">
        <button type="button" style="display: none;" class="btn savedraftbtn" (click)="onSubmit(SaveMode.DRAFT)">
          <i class="fas fa-save mr-2"></i>SAVE AS DRAFT
        </button>
        <button type="button" class="btn prevbtn" (click)="goToBack()">
          <i class="fas fa-arrow-left mr-2"></i>PREVIOUS
        </button>
        <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
          <i class="fas fa-arrow-right mr-2"></i>NEXT
        </button>
      </div>
      <!-- Buttons ends -->

      <!-- Image Preview Popup -->
      <div class="image-preview-popup" 
           *ngIf="showPreview" 
           [style.left.px]="previewPosition.x" 
           [style.top.px]="previewPosition.y">
        <div class="preview-content">
          <img [src]="previewImageUrl" alt="Image Preview" class="preview-image">
          <div class="preview-close" (click)="hideImagePreview()">×</div>
        </div>
      </div>

    </div>
  


   